import { AggregateField, AggregateTarget } from '../../WbsItemEntity'
import { WorkloadUnit } from '../../../../lib/functions/workload'
import { ColumnState } from 'ag-grid-community'

export type VersionReportTemplateEntity = {
  uuid: string
  name: string
  pages: VersionReportTemplatePageEntity[]
  updatedAt: Date
  updatedBy: string
}

export const updateTemplate = (
  src: VersionReportTemplateEntity,
  newName: string,
  newPages: VersionReportTemplatePageEntity[]
): VersionReportTemplateEntity => {
  return {
    ...src,
    name: newName.trim(),
    pages: newPages,
  }
}

export type VersionReportTemplatePageEntity = {
  uuid: string
  pageTitle: string
  pageNumber: number
  pageType: VersionReportPageType
  config: VersionReportPageConfig
}

export type VersionReportPageConfig =
  | ProgressOverviewPageConfig
  | ProgressReportByProcessPageConfig
  | ProgressReportByTeamPageConfig
export type ProgressOverviewPageConfig = {
  type: 'PROGRESS_OVERVIEW'
  targetUuids: string[]
}
export type ProgressReportByProcessPageConfig = {
  type: 'PROGRESS_REPORT_BY_PROCESS'
  tableRows: string[]
  aggregateField: AggregateField
  aggregateTarget: AggregateTarget
  workloadUnit: WorkloadUnit
  columnState: StoredColumnState[]
  rowHeight: number | undefined
}
export type ProgressReportByTeamPageConfig = {
  type: 'PROGRESS_REPORT_BY_TEAM'
  rootUuid: string | undefined
  tableRows: string[]
}

export type VersionReportPageType =
  | 'PROGRESS_OVERVIEW'
  | 'PROGRESS_REPORT_BY_PROCESS'
  | 'PROGRESS_REPORT_BY_TEAM'

export type StoredColumnState = Pick<
  ColumnState,
  'colId' | 'hide' | 'width' | 'pinned'
>
export const toStoredColumnState = (
  columnState: ColumnState
): StoredColumnState => {
  return {
    colId: columnState.colId,
    hide: columnState.hide,
    width: columnState.width,
    pinned: columnState.pinned,
  }
}
